
import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const SubmitButton = (props) => {
    const { translate: t } = useLocale();

    return (
        <button
            className='bg-orange rounded-button text-white type-style-10 px-20 py-15'
            {...props}
            type='submit'>
            {props.children || t('Submit')}
        </button>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

SubmitButton.propTypes = {
    children: PropTypes.any
};

export default SubmitButton;
